(function () {
    'use strict';

    angular.module('formonlineApp')
        .config(accessibilityConfig);

    accessibilityConfig.$inject = ['$ariaProvider'];

    function accessibilityConfig($ariaProvider) {
        $ariaProvider.config({
            tabindex: false
        });
    }
})();
